module.exports = "pegasus/assets/tech/header-image.jpg";